import { AppNavbar, Button, Container, Segmented, Text } from '@ui'
import { Route, Routes } from 'react-router-dom'
import AppFooter from './AppFooter.jsx'
import { RequireAuth, useAuth } from './auth.jsx'
import { APP_NAME } from './brand.js'
import Calendar from './pages/Calendar.jsx'
import Credits from './pages/Credits.jsx'
import DeletedPhotos from './pages/DeletedPhotos.jsx'
import Home from './pages/Home.jsx'
import Photos from './pages/Photos.jsx'
import Privacy from './pages/Privacy.jsx'
import SharedWalk from './pages/SharedWalk.jsx'
import Targets from './pages/Targets.jsx'
import Terms from './pages/Terms.jsx'
import Walk from './pages/Walk.jsx'
import Walks from './pages/Walks.jsx'
import { useUnit } from './units.jsx'

const NAV_LINKS = [
  { to: '/walks', label: 'Walks' },
  { to: '/calendar', label: 'Calendar' },
  { to: '/targets', label: 'Targets' },
  { to: '/photos', label: 'Photos' },
]

export default function App() {
  const [unit, setUnit] = useUnit()
  const { status, email, config, signOut } = useAuth()
  const signedIn = status === 'signed-in'
  return (
    <>
      {/* On phones the links fold into a menu; the unit toggle stays visible. Both only when signed
          in: the public pages (home, Credits, Privacy, Terms) show no distances. */}
      <AppNavbar
        brand={APP_NAME}
        links={signedIn ? NAV_LINKS : []}
        tools={signedIn && (
          <Segmented
            name="unit" size="sm" onDark value={unit} onChange={setUnit} aria-label="Distance unit"
            options={[{ value: 'mi', label: 'mi' }, { value: 'km', label: 'km' }]}
          />
        )}
        end={signedIn && config?.enabled && (
          <>
            <Text tone="onDarkMuted" text="small" hideBelow="md">{email}</Text>
            <Button size="sm" onDark onClick={signOut}>Sign out</Button>
          </>
        )}
      />
      <Container as="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/credits" element={<Credits />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/s/:token" element={<SharedWalk />} />
          <Route path="/walks" element={<RequireAuth><Walks /></RequireAuth>} />
          <Route path="/walks/:id" element={<RequireAuth><Walk /></RequireAuth>} />
          <Route path="/calendar" element={<RequireAuth><Calendar /></RequireAuth>} />
          <Route path="/targets" element={<RequireAuth><Targets /></RequireAuth>} />
          <Route path="/photos" element={<RequireAuth><Photos /></RequireAuth>} />
          <Route path="/photos/deleted" element={<RequireAuth><DeletedPhotos /></RequireAuth>} />
          <Route path="*" element={<p>Page not found.</p>} />
        </Routes>
      </Container>
      <AppFooter />
    </>
  )
}
